import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DhwaniMaterialTempFormComponent } from './dhwani-material-temp-form.component';
import { AuthService } from './form-translate/services/auth.service';
import { TempModuleService } from './form-translate/services/temp-module.service';
import { TranslationService } from './form-translate/services/transation.service.service';
import { MaterialModule } from './shared/material/material.module';
import { TempFormsModule } from './temp-forms/temp-forms.module'


@NgModule({
  declarations: [DhwaniMaterialTempFormComponent],
  imports: [
    TempFormsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [DhwaniMaterialTempFormComponent,TempFormsModule],
  providers:[TempModuleService,TranslationService]
})
export class DhwaniMaterialTempFormModule {
  public static forRoot(environment: any): ModuleWithProviders {

    return {
        ngModule: DhwaniMaterialTempFormModule,
        providers: [
          TempModuleService,
            {
                provide: 'env', // you can also use InjectionToken
                useValue: environment
            },
            TranslationService,
            {
              provide: 'env', // you can also use InjectionToken
              useValue: environment
          },
          AuthService ,
          {
            provide: 'env', // you can also use InjectionToken
            useValue: environment
        },
        ]
    };
}
 }
